import React from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar, Repeat, CheckCircle, Eye } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

const PlanningInfoFooter = () => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardContent className="p-6">
        <div className="flex items-start gap-4">
          <div className="p-3 rounded-xl" style={{ backgroundColor: "rgba(94,106,210,0.12)" }}>
            <Calendar className="h-6 w-6" style={{ color: "#5e6ad2" }} />
          </div>
          <div className="flex-1">
            <h4 className="font-semibold text-foreground text-base mb-2">{t("planning.infoFooter.title")}</h4>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {t("planning.infoFooter.description")}
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-5">
              <div className="flex items-center gap-2.5 text-sm text-foreground font-medium">
                <div className="p-1.5 bg-muted rounded-lg"><Repeat className="h-4 w-4 text-muted-foreground" /></div>
                <span>{t("planning.infoFooter.features.cycles")}</span>
              </div>
              <div className="flex items-center gap-2.5 text-sm text-foreground font-medium">
                <div className="p-1.5 bg-muted rounded-lg"><CheckCircle className="h-4 w-4 text-muted-foreground" /></div>
                <span>{t("planning.infoFooter.features.workflow")}</span>
              </div>
              <div className="flex items-center gap-2.5 text-sm text-foreground font-medium">
                <div className="p-1.5 bg-muted rounded-lg"><Eye className="h-4 w-4 text-muted-foreground" /></div>
                <span>{t("planning.infoFooter.features.tolerances")}</span>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PlanningInfoFooter;
